export default {
    navHome: "होम",
    navProspect: "संभावित ग्राहक",
    navCompanies: 'कंपनियाँ',
    navEnrich: 'समृद्ध करें',
    navIntent: "वेबसाइट इंटेंट",
    navSequence: "अनुक्रम",
    navInbox: "इनबॉक्स",
    navInboxDesc: "ईमेल और LinkedIn संदेशों को एक स्थान पर पढ़ें और जवाब दें",
    inboxSearchPlaceholder: "वार्तालाप खोजें",
    inboxEmptyState: "अभी तक कोई वार्तालाप नहीं। आपके अनुक्रम शुरू होने पर उत्तर यहाँ दिखाई देंगे।",
    inboxEmptyConnectCta: "अनुक्रम सेट करें",
    channelEmail: "ईमेल",
    channelLinkedIn: "लिंक्डइन",
    inboxMsgYou: "आप",
    inboxSelectThreadTitle: "एक वार्तालाप चुनें",
    inboxThreadErrorTitle: "यह वार्तालाप लोड नहीं किया जा सका",
    inboxThreadErrorHint: "इस थ्रेड का कोई सक्रिय चैनल कनेक्शन नहीं है, या डेटा अब उपलब्ध नहीं है।",
    inboxComposerHint: "भेजने के लिए ⌘ + Enter दबाएँ",
    inboxToggleProspect: "प्रॉस्पेक्ट विवरण टॉगल करें",
    inboxChannelFilter: "चैनल फ़िल्टर",
    inboxProspectContact: "संपर्क",
    inboxProspectSequence: "अनुक्रम",
    inboxProspectActivity: "गतिविधि",
    inboxProspectLastInbound: "अंतिम उत्तर",
    inboxProspectLastOutbound: "अंतिम भेजा",
    inboxProspectStatus: "स्थिति",
    inboxProspectNoContact: "कोई संपर्क जानकारी उपलब्ध नहीं।",
    inboxBulkSelected: "चयनित",
    inboxBulkMarkRead: "पढ़ा",
    inboxBulkToggle: "वार्तालाप चुनें",
    inboxTabProfile: "प्रोफ़ाइल",
    inboxTabActivity: "गतिविधि",
    inboxActivityEmpty: "इस वार्तालाप के लिए अभी तक कोई गतिविधि नहीं।",
    inboxInsertVariable: "वेरिएबल",
    inboxVarFullName: "पूरा नाम",
    inboxVarCompany: "कंपनी",
    inboxVarTitle: "पद",
    inboxSequenceStep: "चरण",
    inboxSequenceRunning: "चल रहा है",
    inboxSequencePaused: "रोका गया",
    inboxSequenceFinished: "समाप्त",
    inboxSequenceArchived: "संग्रहीत",
    inboxAsideConversations: "वार्तालाप",
    inboxBulkToggleAll: "इस पृष्ठ का सब चुनें",
    inboxSortBy: "क्रमबद्ध करें",
    inboxSortRecent: "नवीनतम पहले",
    inboxSortOldest: "पुराने पहले",
    inboxSortSender: "प्रेषक (A→Z)",
    inboxSortSubject: "विषय (A→Z)",
    inboxSortReplied: "उत्तरित पहले",
    last_message_at: "नवीनतम संदेश",
    first_message_at: "पहला संदेश",
    reference_id: "प्रेषक",
    subject: "विषय",
    inboxAccountSingular: "खाता",
    inboxAccountPlural: "खाते",
    inboxRecentReplies: "हाल के उत्तर",
    inboxConnectedAs: "जुड़ा हुआ",
    inboxActionInterested: "रुचि रखता है के रूप में चिह्नित करें",
    inboxActionMarkAll: "सभी चिह्नित करें",
    inboxSelectThreadHint: "संदेश देखने के लिए एक वार्तालाप चुनें।",
    inboxReplyPlaceholder: "उत्तर लिखें…",
    inboxSuggestReply: "AI सुझाव",
    inboxSend: "भेजें",
    inboxFilterAll: "सभी",
    inboxFilterUnread: "अपठित",
    inboxFilterReplied: "उत्तरित",
    inboxFilterSnoozed: "स्थगित",
    inboxFilterClosed: "बंद",
    inboxActionSnooze: "स्थगित करें",
    inboxActionMeetingBooked: "मीटिंग बुक की गई",
    inboxActionNotInterested: "रुचि नहीं",
    inboxActionArchive: "संग्रहित करें",
    inboxActionStopSequence: "अनुक्रम बंद करें",
    inboxArchetypeConcise: "संक्षिप्त",
    inboxArchetypeWithCta: "CTA के साथ",
    inboxArchetypeQuestionBack: "जवाबी सवाल",
    actions: "क्रियाएं",
    loading: "लोड हो रहा है…",
    navService: "सेवाएं",
    navAccountCredit: "खाता क्रेडिट",
    navSetting: "सेटिंग",
    navSequenceDetail: "अनुक्रम विवरण",
    companyDetail: "कंपनी विवरण",
    


    // nav desc
    filterYourSearchToFindPreciselyTargeted: "ठीक से लक्षित कंपनियों की सूची खोजने के लिए अपनी खोज को फ़िल्टर करें",
    filterYourSearchToFindHighlySpecific: "अत्यधिक विशिष्ट लक्षित लीड के समूह खोजने के लिए अपनी खोज को फ़िल्टर करें",
    instantlyEnhanceYourData: "विभिन्न स्रोतों से मूल्यवान अंतर्दृष्टि और प्रमुख विवरण जोड़कर तुरंत अपने डेटा को समृद्ध करें",
    transformAnonymousWebsiteTrafficInto: "वास्तविक समय की पहचान के साथ अज्ञात वेबसाइट ट्रैफ़िक को बी2बी लीड में बदलें",
    personalizeYourOutreach: 'समय बचाने और अपने संभावित ग्राहकों को संलग्न करने के लिए अपनी आउटरीच को स्वचालित और वैयक्तिकृत करें',
    comprehensiveBusinessSolutions: 'आपकी आवश्यकताओं के लिए व्यापक व्यावसायिक समाधान और सहायता सेवाएं',


    discoverAndConnectWithPotentialBuyers: "संभावित खरीदारों को खोजें और उनसे जुड़ें",
    activelySeekingYourSolutionToday: "आज सक्रिय रूप से आपके समाधान की तलाश में",
    Market_Intent: "बाजार का इरादा",
    Tools: "उपकरण",
    technologyLookup: "प्रौद्योगिकी खोज",
    domainLookup: "डोमेन खोज",
    emailVerification: "ईमेल सत्यापन",
    upgrade: "अपग्रेड करें",
    helpCenter: "सहायता केंद्र",
    contactUs: "हमसे संपर्क करें",
    feedback: "प्रतिक्रिया",
    hello: "नमस्ते",
    clickToChange: "बदलने के लिए क्लिक करें",
    yourProfile: "आपकी प्रोफ़ाइल",
    currentUsage: "वर्तमान उपयोग",
    upgradePlan: "योजना अपग्रेड करें",
    integrations: "एकीकरण",
    featureRequests: "सुविधा अनुरोध",
    change: "बदलें",
    en: "अंग्रेजी",
    cn: "中文（简）",
    tw: "中文（繁）",
    logout: "लॉग आउट",
    switchLanguage: "भाषा सफलतापूर्वक बदल गई",

    // button operation
    btnEdit: "संपादित करें",
    btnDelete: "हटाएँ",
    btnCancel: 'रद्द करें',
    btnFilters: "फ़िल्टर",
    btnView: 'देखें',
    btnAdd: 'जोड़ें',
    btnRemove: 'हटाएँ',

    // 操作提示
    removeSuccessfully: "सफलतापूर्वक हटा दिया गया",
    saveSuccessfully: "सफलतापूर्वक सहेजा गया",
    createSuccessfully: "सफलतापूर्वक बनाया गया",


    // 系统popup
    unableToProcessPayment: 'भुगतान संसाधित करने में असमर्थ: आपके सबसे हाल के चालान पर भुगतान पूरा नहीं किया जा सका।',
    billingSettings: "बिलिंग सेटिंग्स",

    // wallet
    topupCredit: "क्रेडिट टॉप-अप करें",
    autoTopup:"स्वचालित टॉप-अप",
    lastCalculated: "अंतिम गणना",
    Enabled: "सक्षम",
    Disabled: "अक्षम",

    // user
    btnUpgrade: "अपग्रेड करें",

    // app update toast
    newVersionAvailable:
      "<strong>एक नया संस्करण उपलब्ध है</strong> — नवीनतम सुविधाएँ और सुधार प्राप्त करने के लिए पुनः लोड करें। इस पृष्ठ पर सहेजे न गए परिवर्तन खो सकते हैं।",
    Reload: "पुनः लोड करें",
    // TODO: translate (placeholders copied from en.js)
    inboxStatsToday: "Today",
    inboxStatsReplies: "Replies",
    inboxStatsPending: "Pending",
    inboxStatsActiveSequences: "Active sequences",
    inboxOpenEmpty: "Open the inbox to see your latest replies.",
    inboxRefresh: "Refresh inbox",
    inboxSuggestFollowUp: "Suggest follow-up",
    inboxInsightAge: "Age",
    inboxSuggestModePick: "Choose draft type",
    inboxSuggestModeReply: "Reply (prospect wrote last)",
    inboxSuggestModeFollowUp: "Follow-up (we wrote last)",
    inboxSuggestModeAuto: "Auto (detect from thread)",
    inboxFilterArchived: "Archived",
    inboxFilterDone: "Done",
    inboxStatusMeetingBooked: "Meeting booked",
    inboxStatusNotInterested: "Not interested",
    inboxStatusInterested: "Interested",
    inboxFilterOpen: "Active",
    inboxMsgSent: "Sent",
    inboxClickToOpen: "Click to open",
    inboxKpiSentToday: "Sent today",
    inboxKpiUnread: "Unread",
    inboxKpiRepliedToday: "Replies",
    inboxKpiSentWeek: "Sent this week",
    inboxKpiInbox: "in inbox",
    inboxKpiTotal: "total",
    inboxGlanceTopSequences: "Top sequences (30 days)",
    inboxLinkBtn: "Link",
    inboxLinkPromptUrl: "Link URL",
    inboxLinkPromptErr: "Enter a URL starting with http(s)://",
    inboxComposerDropHint: "Drop to attach",
    inboxFilterChannel: "Channel",
    inboxFilterCredential: "Credential",
    inboxFilterSequence: "Sequence",
    inboxFilterStatus: "Status",
    inboxFilterClassification: "Reply type",
    inboxFilterDateRange: "Date range",
    inboxFilterDateRangePh: "Pick a date range",
    inboxFilterClass_real: "Real replies only",
    inboxFilterClass_bounce: "Bounces",
    inboxFilterClass_auto_reply: "Auto-replies",
    inboxClassBounce: "Bounce",
    inboxClassBounceHint: "Delivery failed — this isn't a real reply",
    inboxClassAutoReply: "Auto-reply",
    inboxClassAutoReplyHint: "Automated out-of-office / vacation responder",
    inboxStepEvents: "events",
    inboxBulkMarkUnread: "Unread",
    inboxBulkInterested: "Interested",
    inboxBulkNotInterested: "Not interested",
    inboxSnoozeDialogTitle: "Snooze until",
    inboxSnoozeCustom: "Pick a custom date and time",
    inboxSnoozeCustomPh: "Select date & time",
    inboxSnoozeConfirm: "Snooze",
    inboxSnoozePreset1h: "Later today (1h)",
    inboxSnoozePreset4h: "Later today (4h)",
    inboxSnoozePresetTom: "Tomorrow morning",
    inboxSnoozePresetMon: "Next Monday",
    inboxSnippetBtn: "Snippets",
    inboxSnippetSearch: "Search snippets",
    inboxSnippetNew: "New snippet",
    inboxSnippetManage: "Manage",
    inboxSnippetCreate: "Create your first snippet",
    inboxSnippetCreateTitle: "New snippet",
    inboxSnippetEditTitle: "Edit snippet",
    inboxSnippetManager: "Manage snippets",
    inboxSnippetEmpty: "No saved snippets yet.",
    inboxSnippetFieldName: "Name",
    inboxSnippetFieldChannel: "Channel (optional)",
    inboxSnippetFieldBody: "Body",
    inboxSnippetChannelAny: "Any channel",
    inboxSnippetNamePh: "e.g. Friendly follow-up",
    inboxSnippetBodyPh: "Hi {{first_name}}, just following up…",
    btnSave: "Save",
    inboxProspectTracking: "Tracking",
    inboxOpened: "Opened",
    inboxClicked: "Clicked",
    inboxLast: "last",
    of: "of",
    inboxAttachBtn: "Attach",
    inboxAttachTooBig: "Total attachment size exceeds 24MB.",
    noData: "No results",
    inboxCopy: "Copy",
    inboxCopied: "Copied",
    inboxCopyEmail: "Copy email",
    inboxCopiedEmail: "Email copied",
    inboxCopyPhone: "Copy phone",
    inboxCopiedPhone: "Phone copied",
    inboxOpenLinkedIn: "Open LinkedIn",
    inboxOpenTwitter: "Open X / Twitter",
    inboxProspectCompany: "Company",
    inboxProspectInsights: "Insights",
    inboxInsightMessages: "Messages",
    inboxInsightSince: "Open",
    inboxAgeToday: "Today",
    inboxEmptyTitle: "No conversations yet",
    inboxSelectionPicker: "Selection options",
    inboxSelectionTitle: "Select conversations",
    inboxSelectThisPage: "This page",
    inboxSelectAll: "All conversations",
    inboxSelectCustom: "Custom",
    inboxSelectAllHint: "Selecting beyond this page fetches additional pages from the server.",
    applySelection: "Apply",
    theQuantityCannotBeZero: "Pick a non-zero count",
    inboxCompanyName: "Name",
    inboxCompanyIndustry: "Industry",
    inboxCompanySize: "Size",
    inboxCompanyLocation: "Location",
    inboxCompanyWebsite: "Website",
    inboxCompanyLinkedIn: "LinkedIn",
    inboxShowTrimmed: "Show trimmed content",
    inboxShowTrimmedHint: "Show the rest of this message",
    inboxFieldTo: "To",
    inboxFieldToPh: "recipient@example.com",
    inboxFieldToLinkedInPh: "Recipient",
    inboxFieldCc: "Cc",
    inboxFieldCcPh: "cc@example.com, …",
    inboxFieldBcc: "Bcc",
    inboxFieldBccPh: "bcc@example.com, …",
    inboxFieldSubject: "Subject",
    inboxFieldSubjectPh: "Subject",
    inboxFieldLocked: "Auto-filled — cannot edit",
    inboxTrackSent: "Sent",
    inboxTrackSentHint: "Messages we sent in this thread",
    inboxTrackReplies: "Replies",
    inboxTrackRepliesHint: "Inbound messages from the prospect",
    inboxTrackOpens: "Opens",
    inboxTrackOpensHint: "Times the recipient opened a tracked message",
    inboxTrackClicks: "Clicks",
    inboxTrackClicksHint: "Tracked links the recipient clicked",
    inboxTrackReads: "Reads",
    inboxTrackReadsHint: "Times the recipient read this thread (LinkedIn read receipts)",
    inboxTrackReactions: "Reactions",
    inboxTrackReactionsHint: "Reactions on our outbound messages",
    inboxMsgNoOpenYet: "No opens recorded yet",
    inboxMsgNoClickYet: "No clicks recorded yet",
    inboxActivityReplyReceived: "Reply received",
    inboxActivityOpenRecorded: "Email opened",
    inboxActivityClickRecorded: "Link clicked",
    inboxActivitySendEmail: "Email sent",
    inboxActivitySendLinkedIn: "LinkedIn message sent",
    inboxActivitySendInvite: "LinkedIn invite sent",
    inboxActivityFailed: "failed",
    inboxComposerExpand: "Expand composer",
    inboxComposerCollapse: "Collapse composer",
    inboxComposerMinimise: "Minimise composer",
    inboxComposerRestore: "Restore composer",
    inboxComposerReply: "Reply…",
    inboxReplyModeReply: "Reply",
    inboxReplyModeReplyAll: "Reply all",
    inboxRecipientNoMatch: "Type an email and press Enter",
    inboxSignatureToggle: "Toggle signature",
    inboxSignatureTitle: "Email signature",
    inboxSignaturePh: "Best regards,\nYour name",
    inboxSignatureOn: "Signature ON — click to remove",
    inboxSignatureOff: "Signature OFF — click to insert",
    inboxSignatureRightClickEdit: "right-click to edit",
    inboxSignatureRightClickHint: "Tip: right-click the signature button to edit.",
    Refresh: "Refresh",
    Show: "Show",
    Hide: "Hide",
    Next: "Next",
};